import axios from 'axios'
import * as vars from './vars';

export function getAdminPageSummaryData(getAdminPageSummaryDataRequest, jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + `/api/v3/admin/GetAdminPageSummaryData`,
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: getAdminPageSummaryDataRequest
    })
}

export function getAdminPageUserData(getAdminPageUserDataRequest, jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + `/api/v3/admin/GetAdminPageUserData`,
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: getAdminPageUserDataRequest
    })
}

export function refreshUserCache() {
    return axios({
        method: 'PATCH',
        url: vars.baseURL + `/api/v3/untrusted/authentication/RefreshUserCache`,
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken},
        data: {}
    })
}

export function getAdminPageScheduleData(getAdminPageScheduleDataRequest, jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + `/api/v3/admin/GetAdminPageScheduleData`,
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: getAdminPageScheduleDataRequest
    })
}

export function getAdminPageNotificationsData(getAdminPageNotificationsDataRequest, jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + `/api/v3/admin/GetAdminPageNotificationsData`,
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: getAdminPageNotificationsDataRequest
    })
}

export function getAdminPageMediaData(getAdminPageMediaDataRequest, jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + `/api/v3/admin/GetAdminPageMediaData`,
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: getAdminPageMediaDataRequest
    })
}

export function getAdminPagePaymentsData(getAdminPagePaymentsDataRequest, jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + `/api/v3/admin/GetAdminPagePaymentsData`,
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: getAdminPagePaymentsDataRequest
    })
}


export function getAdminPageSupportData(getAdminPageSupportDataRequest, jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + `/api/v3/admin/GetAdminPageSupportData`,
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: getAdminPageSupportDataRequest
    })
}


